import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';

export const GOOGLE_PLAY_APP_URL = 'https://play.google.com/store/apps/details?id=com.m2stats.mobile';

export default function MobileAppCta({ compact = false, sx = {} }) {
  return (
    <Alert
      severity="success"
      icon={<AndroidIcon fontSize="inherit" />}
      sx={{
        mb: compact ? 2 : 3,
        overflow: 'hidden',
        '& .MuiAlert-message': { width: '100%', minWidth: 0 },
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent="space-between"
        sx={{ minWidth: 0 }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant={compact ? 'body2' : 'subtitle2'} fontWeight={700}>
            Prefer tracking from your phone?
          </Typography>
          <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
            Download the M2 Stats Android app to analyze mobile money SMS transactions and track Money In vs Money Out on the go.
          </Typography>
        </Box>
        <Button
          component="a"
          href={GOOGLE_PLAY_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="success"
          size="small"
          startIcon={<AndroidIcon />}
          sx={{
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            alignSelf: { xs: 'stretch', sm: 'flex-start', md: 'center' },
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
            Get it on Google Play
          </Box>
          <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
            Google Play
          </Box>
        </Button>
      </Stack>
    </Alert>
  );
}
